import React, { useState, useEffect, useRef } from "react";
import { Container } from "../../components/Container/Container";
import i18n from "i18next";
import GetCards from "../../components/GetCards/GetCards";
import { H3 } from "../../styles/typography/typography"

import { HeaderStyled } from "./style";

import { ContainerCatalogStyled } from "../../components/Container/style";

// количество источников (GetCards), которые запрашиваются на странице результатов поиска
const SEARCH_SOURCES_COUNT = 7;

const SearchResult = ({ searchWorld }) => {
    const [searchShow, setSearchShow] = useState(true);
    const [countCards, setCountCards] = useState(0);
    const [loadedSourcesCount, setLoadedSourcesCount] = useState(0);

    const timers = useRef([]);
    useEffect(() => () => { timers.current.forEach(clearTimeout) }, []);

    // проверяем есть ли хотя бы одна найденная карта. В зависимости от результата выводим нужный текст
    // также считаем, сколько источников уже ответили, чтобы не показывать "ничего не найдено" во время загрузки
    const _countCards = (x) => {
        setCountCards((prev) => prev + x);
        setLoadedSourcesCount((prev) => prev + 1);
    };

    // componentDidUpdate: сбрасываем результаты при новом поисковом запросе
    const isFirstRender = useRef(true);
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        setCountCards(0);
        setLoadedSourcesCount(0);
        setSearchShow(false);
        timers.current.push(setTimeout(() => {
            setSearchShow(true);
        }, 30));
    }, [searchWorld]);

    // идёт ли ещё загрузка результатов (не все источники успели ответить)
    const isSearchLoading = searchWorld !== "" && (!searchShow || loadedSourcesCount < SEARCH_SOURCES_COUNT);

    return (
        <ContainerCatalogStyled>
            <Container>
                {!isSearchLoading && countCards > 0 && <HeaderStyled>
                    <H3 as="h1">{i18n.t(`search.searching_results`)} «{searchWorld}»</H3>
                </HeaderStyled>}
                {!isSearchLoading && countCards === 0 && <HeaderStyled>
                    <H3 as="h1">{i18n.t(`search.no_results`)}</H3>
                </HeaderStyled>}
            </Container>
            <Container>
                {(searchShow && searchWorld !== "") && <>
                    <GetCards sourceCards={`projects?filter%5Btitle%5D=${searchWorld}`} title={i18n.t(`filter.search_by_name`)} type="catalog" cardDisplayType="carousel" _countCards={(x) => _countCards(x)} />
                </>}
            </Container>
            <Container>
                {(searchShow && searchWorld !== "") && <>
                    <GetCards sourceCards={`projects?filter%5Bcategory_id%5D=1&filter%5Bsearch%5D=${searchWorld}`} title={i18n.t(`filter.category.${0}.animation`)} link="/catalog" type="catalog" cardDisplayType="carousel" _countCards={(x) => _countCards(x)} />
                    <GetCards sourceCards={`projects?filter%5Bcategory_id%5D=2&filter%5Bsearch%5D=${searchWorld}`} title={i18n.t(`filter.category.${0}.documentaries`)} link="/catalog" type="catalog" cardDisplayType="carousel" _countCards={(x) => _countCards(x)} />
                    <GetCards sourceCards={`projects?filter%5Bcategory_id%5D=4&filter%5Bsearch%5D=${searchWorld}`} title={i18n.t(`filter.category.${0}.programs`)} link="/catalog" type="catalog" cardDisplayType="carousel" _countCards={(x) => _countCards(x)} />
                    <GetCards sourceCards={`projects?filter%5Bcategory_id%5D=5&filter%5Bsearch%5D=${searchWorld}`} title={i18n.t(`filter.category.${0}.series`)} link="/catalog" type="catalog" cardDisplayType="carousel" _countCards={(x) => _countCards(x)} />
                    <GetCards sourceCards={`projects?filter%5Bcategory_id%5D=3&filter%5Bsearch%5D=${searchWorld}`} title={i18n.t(`filter.category.${0}.films`)} link="/catalog" type="catalog" cardDisplayType="carousel" _countCards={(x) => _countCards(x)} />
                    <GetCards sourceCards={`events?filter%5Bsearch%5D=${searchWorld}`} title={i18n.t(`header.menuList.${1}.title`)} link="/events" type="events" cardDisplayType="carousel" _countCards={(x) => _countCards(x)} />
                    <GetCards sourceCards={`collections?filter%5Bsearch%5D=${searchWorld}`} title={i18n.t(`header.menuList.${2}.title`)} link="/collections" type="collections" cardDisplayType="carousel" _countCards={(x) => _countCards(x)} />
                </>}
            </Container>
        </ContainerCatalogStyled>
    )
};

export default SearchResult;
